import React, { useState } from 'react';
import { Close } from '@mui/icons-material';
import {
  ButtonBase,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Typography,
} from '@mui/material';

import appStrings from '../../app_strings';
import appColors from '../../app_colors';
import { BackrsForm } from '../BackrsForm/BackrsForm';
import { handlePhoneLogin } from '../../atoms/Login/login.util';

const LOGIN_STRINGS = appStrings.login.unified;

const defaultForgotPasswordValues = {
  forgotPasswordEmail: '',
};

const noCodeStyle = {
  mb: 2,
};

const noCodeTextStyle = {
  fontSize: '0.9375rem',
  fontWeight: 700,
};

const contactSupportTextStyle = {
  fontSize: '0.8125rem',
  textAlign: 'center',
  mt: 1,
};

const contactSupportLinkStyle = {
  color: appColors.text.navy,
  fontWeight: 700,
  textDecoration: 'none',
  cursor: 'pointer',
};

const dialogCloseButtonStyle = {
  position: 'absolute',
  right: 8,
  top: 8,
};

export const ResendCode = ({ environmentUrl, onResend }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const fields = [
    {
      id: 'phone',
      name: 'phone',
      placeholder: LOGIN_STRINGS.phonePlaceholder,
      type: 'tel',
      autoComplete: 'phone',
      inputProps: { maxLength: 10 },
      icon: {
        type: 'LEFT_ICON',
        leftIcon: 'Phone',
        leftIconColor: appColors.buttons.secondaryBackground,
        enableFill: true,
      },
      rules: {
        pattern: { value: /^\d{10}$/, message: LOGIN_STRINGS.error.invalidPhone },
      },
    },
  ];

  const handleSubmission = async (data) => {
    try {
      await handlePhoneLogin(data.phone, environmentUrl);

      // todo: use react-hot-toast after sending successful pw reset
    } catch {
      console.log('Error resending verification code');
    } finally {
      closeModal();
      await onResend(data);
    }
  };

  return (
    <>
      <ButtonBase sx={noCodeStyle} onClick={openModal} disableRipple>
        <Typography sx={noCodeTextStyle}>{LOGIN_STRINGS.otp.noCode}</Typography>
      </ButtonBase>
      <Dialog
        PaperProps={{
          style: { borderRadius: 8 },
        }}
        open={isOpen}
        onClose={closeModal}
      >
        <DialogTitle mt={2}>
          <IconButton aria-label="close" onClick={closeModal} sx={dialogCloseButtonStyle}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography>{LOGIN_STRINGS.otp.resendCode}</Typography>
          <BackrsForm
            fields={fields}
            defaultValues={defaultForgotPasswordValues}
            buttonLabel="Send"
            onSubmit={handleSubmission}
          >
            <Typography sx={contactSupportTextStyle}>
              {LOGIN_STRINGS.otp.contactSupportPrompt}
              <Link
                href="mailto:support@backrs.com?subject=Backrs App - Contact Request"
                sx={contactSupportLinkStyle}
              >
                {LOGIN_STRINGS.otp.contactSupportButton}
              </Link>
            </Typography>
          </BackrsForm>
        </DialogContent>
      </Dialog>
    </>
  );
};
